<template>
  <form @submit.prevent ref="form" autocomplete="off">
    <ValidationObserver ref="observer" v-slot="{}">
      <ValidationProvider
          v-slot="{}"
          rules=""
          name="type-text"
          ref="message_text"
      >
        <div
            ref="textEditor"
            class="text-editor scrollbar-custom"
            style="width:100%; height: 100%; text-align: left"
            :contenteditable="!disabled"
            v-on="listeners"
            :data-placeholder="placeholder"
            :class="{...classes, 'disabled': disabled}"
            autocomplete="off"
            autocorrect="on"
            autocapitalize="sentences"
            spellcheck="true"
        />
      </ValidationProvider>
    </ValidationObserver>
  </form>
</template>
<script>
  import {ValidationObserver, ValidationProvider} from 'vee-validate';
  import {decodeEntities} from "@/util/chat";

  export default {
    name: "TypeText",
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      chat_id: {
        type: String,
        default: ""
      },
      message_send: {
        type: Boolean,
        default: false
      },
      defaultValue: {
        type: Object,
        default: () => {
        }
      },
      firefindContact: {
        type: Function,
        default: () => {
        }
      },
      showSuggestion: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      selection: null,
      range: null,
      placeholder: "Type a message…  (Enter to send · Shift+Enter for a new line)",
      suggestions: [],
      message_text: "",
      currentWord: "",
      classes: {
        placeholder: true
      }
    }),
    watch: {
      async message_text() {
        const self = this;
        const isValid = await self.$refs.observer.validate();

        this.currentWord = this.getWordAt(self.$refs.textEditor.innerText, this.getCaretPosition());
        if (this.currentWord && this.currentWord.indexOf("@") === 0) {
          self.firefindContact(this.currentWord.substr(1, this.currentWord.length), true);
        } else {
          if (this.currentWord === " ") {
            document.execCommand("foreColor", false, "black");
            document.execCommand("delete", false, "");
            document.execCommand('inserthtml', false, "&nbsp;");
          }
          self.firefindContact(this.currentWord, false);
        }

        self.setter(isValid);
      },
      message_send(update) {
        const self = this;
        if (update) {
          self.$refs.form.reset();
        }
      },
      defaultValue(val) {
        if (val && val.text) {
          this.message_text = val.text;
          this.$refs.textEditor.innerText = val.text;
        } else {
          document.execCommand("foreColor", false, "black");
          document.execCommand( 'inserthtml', false, "&nbsp;");
          document.execCommand( "delete", false, "" );
          this.message_text = this.$refs.textEditor.innerText = "";
          this.classes.placeholder = !this.message_text;
          this.suggestions = [];
        }
      }
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          input: this.onInput,
          // keydown ONLY — binding both keydown+keypress fired onKeyPress twice
          // per Enter, so a mention selection (keydown) was immediately followed
          // by a send (keypress, after showSuggestion flipped). keydown alone
          // handles Arrow/Enter/Escape for both the suggestion picker and send.
          keydown: this.onKeyPress,
          paste: this.onPaste,
          click: this.onClick
        };
      },
    },
    components: {
      ValidationProvider,
      ValidationObserver
    },
    mounted() {
      const self = this;
      const placeholder = this.$refs.textEditor.getAttribute('data-placeholder');
      this.message_text = this.$refs.textEditor.innerText = this.defaultValue && this.defaultValue.text ? this.defaultValue.text : "";
      (this.message_text === '') && (this.$refs.textEditor.innerHTML = placeholder);

      this.$refs.textEditor.addEventListener('focus', function (e) {
        const value = e.target.innerHTML;
        value === placeholder && (e.target.innerHTML = '');
        self.classes.placeholder = self.$refs.textEditor.innerText === placeholder || !self.$refs.textEditor.innerText;
      });

      this.$refs.textEditor.addEventListener('blur', function (e) {
        const value = e.target.innerHTML;
        value === '' && (e.target.innerHTML = placeholder);
        self.classes.placeholder = !value;
      });
    },
    beforeDestroy() {
      //
    },
    methods: {
      focus() {
        // Place focus + cursor at the end of the contenteditable. Called
        // from chat.js when opening a chat and after sending a message so
        // the user can start typing immediately.
        const el = this.$refs.textEditor;
        if (!el) return;
        el.focus();
        try {
          const sel = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(el);
          range.collapse(false);
          sel.removeAllRanges();
          sel.addRange(range);
        } catch (e) { /* ignore */ }
      },
      getTextWithSuggestionsBolded() {
        if (this.$refs.textEditor.innerHTML === this.placeholder) {
          this.$refs.textEditor.innerHTML = "";
        }
        let html = this.$refs.textEditor.innerHTML;
        html = html
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/<\/(div|p|h[1-6]|blockquote|li)>/gi, '\n')
          .replace(/<(div|p|h[1-6]|blockquote|li)[^>]*>/gi, '')
          .replace(/\n{3,}/g, '\n\n')
          .replace(/^\n+/, '')
          .replace(/\n+$/, '');
        return decodeEntities(html);
      },
      selectSuggestion(suggestion) {
        this.suggestions.push(suggestion);
        for(let i = 0; i < this.currentWord.length; i ++) {
          document.execCommand( "delete");
        }
        document.execCommand( "delete");
        if (`${this.currentWord.substr(1, this.currentWord.length)}` !== this.$refs.textEditor.innerText) {
          document.execCommand( 'inserthtml', false, "&nbsp;");
        }
        document.execCommand( "foreColor", false, "black");
        document.execCommand( "bold");
        document.execCommand( "insertText", false, `@${suggestion}` );
        document.execCommand( "bold");
        document.execCommand( "foreColor", false, "black");
        // document.execCommand( "insertText", false, " " );
        document.execCommand( 'inserthtml', false, "&nbsp;");
        this.showSuggestion = false;
        this.currentWord = "";
      },
      addCustom(text) {
        if (this.$refs.textEditor.innerHTML === this.placeholder) {
          this.$refs.textEditor.innerHTML = "";
        }

        if (!this.insertTextAtCaret(text)) {
          this.$refs.textEditor.innerHTML = this.$refs.textEditor.innerHTML + text;
        }

        this.setter(true);
      },
      getCaretPosition() {
        const selection = document.getSelection();
        const childOffset = selection.focusOffset;
        const range = document.createRange();
        const eDiv = this.$refs.textEditor;
        range.setStart(eDiv, 0);
        try {
          range.setEnd(selection.focusNode, childOffset);
          // eslint-disable-next-line no-empty
        } catch (e){
          console.warn('Caret position error:', e);
        }
        let sHtml = range.toString();
        return sHtml.length;
      },
      insertTextAtCaret(text) {
        if (this.range && this.selection) {
          this.range.insertNode(document.createTextNode(text));
          this.range.collapse(false);
          return true;
        }
        return false;
      },
      onClick() {
        this.selection = window.getSelection();
        this.range = this.range = this.selection.getRangeAt(0);
      },
      onInput(e) {
        const text = e.target.innerText;
        if (text.length > 10000) {
          e.target.innerText = text.substring(0, 10000);
          e.preventDefault();
          return;
        }
        this.message_text = e.target.innerText;
        this.$emit('input', e.target.innerText);
        this.classes.placeholder = !this.message_text;
        if (e.target.innerText === " " || e.target.innerText === "\n") {
          document.execCommand("foreColor", false, "black");
          document.execCommand('inserthtml', false, "&nbsp;");
          document.execCommand("delete", false, "");
        }
      },
      onPaste(e) {
        e.preventDefault();
        const cd = e.clipboardData;
        // Paste-an-image-to-upload: if the clipboard holds an image (e.g. a
        // screenshot), hand the file to the composer's upload flow.
        if (cd && cd.items) {
          for (const item of cd.items) {
            if (item.kind === 'file' && item.type && item.type.indexOf('image/') === 0) {
              const file = item.getAsFile();
              if (file) { this.$emit('pasteFile', file); return; }
            }
          }
        }
        // Otherwise paste PLAIN TEXT only — escape HTML so it inserts literally
        // (no injection), preserve newlines as <br>. We deliberately don't honor
        // pasted rich HTML (the old path string-munged tags and was an injection
        // vector + mangled content).
        const plain = (cd && cd.getData("text/plain")) || "";
        if (!plain) return;
        const esc = plain.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        document.execCommand("insertHTML", false, esc.replace(/\r\n?|\n/g, "<br>"));
      },
      async onKeyPress(event) {
        const self = this;
        if (self.showSuggestion) {
          if (event.key === "ArrowDown") {
            event.preventDefault();
            self.$emit("moveSuggestion", "down");
            return;
          }
          if (event.key === "ArrowUp") {
            event.preventDefault();
            self.$emit("moveSuggestion", "up");
            return;
          }
          if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            self.$emit("selectSuggestion");
            return;
          }
          if (event.key === "Escape") {
            event.preventDefault();
            self.$emit("dismissSuggestion");
            return;
          }
        }
        if (event.key === "Enter" && !event.shiftKey) {
          event.preventDefault();
          self.$emit("pressEnter");
        }
      },
      getWordAt(str, pos) {
        // Perform type conversions.
        str = String(str);
        pos = Number(pos) >>> 0;

        // Search for the word's beginning and end.
        var left = str.slice(0, pos + 1).search(/\S+$/),
          right = str.slice(pos).search(/\s/);

        // The last word in the string is a special case.
        if (right < 0) {
          return str.slice(left);
        }

        // Return the word, using the located bounds to extract it from the string.
        return str.slice(left, right + pos);

      },
      setter(isValid) {
        const self = this;

        const param = {
          type: 'text',
          message: {
            chat_id: self.chat_id,
            text: self.message_text,
            type: 'text',
          },
          isValid: isValid,
        };

        if (self.message_text.length > 0) {
          //
        }

        self.$emit("setter", param);
        this.$refs.observer.reset();
      },
      getter() {
        const self = this;

        const param = {
          type: 'text',
          message: {
            chat_id: self.chat_id,
            text: self.message_text,
            type: 'text',
          },
          isValid:  true
        };

        return param;
      },

      submit() {
        this.$refs.observer.reset()
      }
      ,
    },

  }
</script>